module.exports = __webpack_public_path__ + "src/modules/home/training/images/1701.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1701.png
// module id = 784
// module chunks = 0